import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class TokenPBService {
    private tokenPB = new BehaviorSubject('');
    constructor() { }

    setToken(token: string) {
        this.tokenPB.next(token);
    }

    limpiarToken() {
        this.tokenPB.next('');
    }

    getToken(): Observable<any> {
        return this.tokenPB.asObservable();
    }
}